import React, { FC } from 'react'
import { Wrapper, TextWrapper, Title, Subtitle } from './styled'

interface ComponentProps {
	icon: () => JSX.Element
	title: string
	subtitle?: string
	children?: JSX.Element | JSX.Element[]
}

export const ElementWithIconComponent: FC<ComponentProps> = ({
	icon,
	title,
	subtitle,
	children,
}) => (
	<Wrapper>
		{icon()}
		<TextWrapper>
			<Title>{title}</Title>
			<div>
				<Subtitle>{subtitle}</Subtitle>
				<>{children}</>
			</div>
		</TextWrapper>
	</Wrapper>
)
